// Sessions récemment rejointes (par code ou invitation), affichées comme raccourcis
// dans « Entrer le code » tant qu'elles sont actives.
const KEY = "bowlink_recent_sessions";

export function getRecent() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

export function setRecent(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 10))); } catch { /* */ }
}

export function addRecent(kind, code) {
  const c = (code || "").toUpperCase();
  if (!c || (kind !== "solo" && kind !== "match")) return;
  const list = getRecent().filter((e) => !(e.kind === kind && e.code === c));
  list.unshift({ kind, code: c });
  setRecent(list);
}

export function removeRecent(kind, code) {
  const c = (code || "").toUpperCase();
  setRecent(getRecent().filter((e) => !(e.kind === kind && e.code === c)));
}
